import * as React from "react";
import {Grid2 as Grid} from "@mui/material";
import StringInputField from "@/lib/components/inputfields/string-input-field";
import {useTranslation} from "react-i18next";
import {RequestKeyWordsI18N} from "@/translations";
import {DeclineReason} from "@/api/data-contracts";
import {DECLINE_REASON_LABEL_KEYS} from "@/common/request-cards/decline-reason-logic";

export type DeclineReasonDisplayProps = {
    /** The structured decline reason option; always rendered (including {@link DeclineReason.NO_REASON_GIVEN}). */
    declineReason?: DeclineReason | null;
    /** Optional free-text explanation; only rendered when a non-blank value is present. */
    explanation?: string | null;
};

/**
 * Read-only display of a quote's structured decline reason (analogous to {@link FeedbackReasonCard}).
 * Renders the chosen reason option label unconditionally and an optional free-text explanation below it.
 * Returns bare {@code Grid} items intended to be embedded in an existing {@code Grid container}.
 */
export const DeclineReasonDisplay = ({ declineReason, explanation }: DeclineReasonDisplayProps) => {
    const { t } = useTranslation();

    const reasonLabel = declineReason
        ? t(DECLINE_REASON_LABEL_KEYS[declineReason])
        : t(RequestKeyWordsI18N.noRejectReasonAvailable);
    const hasExplanation = Boolean(explanation?.trim());

    return (
        <>
            <Grid size={{ sm: 12 }}>
                <StringInputField label={t(RequestKeyWordsI18N.rejectQuoteReasonLabel)} value={reasonLabel} disabled />
            </Grid>
            {hasExplanation && (
                <Grid size={{ sm: 12 }}>
                    <StringInputField
                        label={t(RequestKeyWordsI18N.rejectQuoteReasonExplanationLabel)}
                        value={explanation?.trim()}
                        multiline
                        minRows={2}
                        disabled
                    />
                </Grid>
            )}
        </>
    );
};
